import { Redeem } from '../features/gamification';

const RedeemScreen = () => {
    return <Redeem />;
};
export default RedeemScreen;
